<div class="notification-wrapper">
  <mat-icon class="material-icons icon">check_circle_outline</mat-icon>
  <span>{{ data.translationKey | translate: data.params }}</span>
</div>
